import { isEqual } from 'lodash';

import { useMediaQuery, MediaQuery } from '../../hooks/useMediaQuery';
import {
  BrandsContentModel,
  ProductCategoryModel
} from '../../interface/products';
import SectionContainer from '../../components/atoms/section-container/section-container';
import { SUBZERO_BRAND_NAME } from '../../constants/brands';
import ProductCategoryCard from '../../components/molecules/product-category-card/product-category-card';
import BookAnAppointment from '../../components/molecules/book-an-appointment/book-an-appointment';
import CategoryRow from '../../components/molecules/category-row/category-row';
import BrandBannerCarousel from '../../components/molecules/brand-banner-carousel/brand-banner-carousel';
import { brandColors } from '../../constants/colors';
import MainProductPageBanner from '../../components/molecules/main-product-page-banner/main-product-page-banner';
import {
  getBrandPageContents,
  getBrandPageContentsByBrand
} from '../../services/products';
import TabTitle from '../../components/atoms/tab-title/tab-title';
import { stringToQuery } from '../../utils/products';

type IndexProps = {
  brandPageContents: BrandsContentModel[];
};

export function Index(props: IndexProps) {
  const { brandPageContents } = props;
  const { attributes } = brandPageContents[0];
  const {
    brandBannerContent,
    brandBannerImage,
    brandDescription,
    brandSlug,
    brandTitle,
    categories
  } = attributes;

  const { SUBZERO_HEX, WOLF_HEX } = brandColors;
  const brandColor = isEqual(brandTitle, SUBZERO_BRAND_NAME)
    ? SUBZERO_HEX
    : WOLF_HEX;

  const textColor = isEqual(brandTitle, SUBZERO_BRAND_NAME)
    ? 'text-primaryBlue'
    : 'text-primaryRed';

  const isTablet = useMediaQuery(MediaQuery.MD);

  const renderCategories = categories.map(
    (category: ProductCategoryModel, i: number) => {
      const imageAlignment = isEqual(i % 2, 0) ? 'left' : 'right';

      return (
        <div className="w-full" key={category.categoryTitle}>
          {isTablet ? (
            <ProductCategoryCard
              brandTitle={brandTitle}
              category={category}
              ctaLink={`/${brandSlug}/${stringToQuery(category.categoryTitle)}`}
            />
          ) : (
            <CategoryRow
              brandTitle={brandTitle}
              category={category}
              ctaLink={`/${brandSlug}/${stringToQuery(category.categoryTitle)}`}
              imageAlignment={imageAlignment}
            />
          )}
        </div>
      );
    }
  );

  return (
    <>
      <TabTitle page={brandTitle} />
      <MainProductPageBanner
        brandBannerImage={brandBannerImage}
        brandDescription={brandDescription}
        brandTitle={brandTitle}
      />
      <SectionContainer>
        <BrandBannerCarousel
          brandBannerContent={brandBannerContent}
          paginationColor={brandColor}
          textColor={textColor}
        />
        {renderCategories}
      </SectionContainer>
      <div className="mt-32 md:mt-0">
        <BookAnAppointment />
      </div>
    </>
  );
}

export async function getStaticProps({ params }: any) {
  const { brand } = params;
  const brandPageContents = await getBrandPageContentsByBrand(brand);

  return {
    props: { brandPageContents }
  };
}

export async function getStaticPaths() {
  const brandPageContents = await getBrandPageContents();
  const paths = brandPageContents.map((brand) => {
    return {
      params: {
        brand: brand.attributes.brandSlug
      }
    };
  });

  return {
    paths,
    fallback: false
  };
}

export default Index;
